import { render, staticRenderFns } from "./PlainUnorderedList.vue?vue&type=template&id=6109cea2&"
import script from "./PlainUnorderedList.vue?vue&type=script&lang=js&"
export * from "./PlainUnorderedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports